import { Icon } from "@sellar-io/components";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { OrderStage } from "../newOrderSummary";
import { useState } from "react";
import { Transition } from "@headlessui/react";
import { usePaymentTermsIndicatorDirect } from "./usePaymentTermsIndicatorDirect";
import { Link } from "react-router";
import {
  BUSINESS_FINANCE_CREDIT_PAYOUT,
  BUSINESS_FINANCE_CREDIT,
  SELLAR_CREDIT_CREDIT_PROVIDER_SELECTION,
} from "../../constants/routes";

export const SellarCreditPaymentTypeIndicator = ({
  canAccessTab,
  userType,
  orderStage,
  invoiceId,
  payoutId,
}: {
  canAccessTab: boolean;
  userType: "supplier" | "buyer";
  orderStage: OrderStage;
  invoiceId?: number;
  payoutId?: number | null;
}) => {
  const { business } = useSellarCurrentBusiness();
  const [showTooltip, setShowTooltip] = useState(false);
  const message =
    orderStage !== "Accepted" &&
    orderStage !== "Requested" &&
    userType === "supplier"
      ? "Invoiced by Sellar"
      : "Sellar Credit";

  const getFinanceLink = () => {
    if (business?.Retailer) {
      return SELLAR_CREDIT_CREDIT_PROVIDER_SELECTION;
    }
    if (payoutId == null) {
      if (invoiceId)
        return `${BUSINESS_FINANCE_CREDIT}?payout=next&invoiceId=${invoiceId}`;
      return `${BUSINESS_FINANCE_CREDIT}?payout=next`;
    }
    if (invoiceId) {
      return `${BUSINESS_FINANCE_CREDIT_PAYOUT}?invoiceId=${invoiceId}`;
    }
    return BUSINESS_FINANCE_CREDIT;
  };

  const financeLink = getFinanceLink();
  const indicator = usePaymentTermsIndicatorDirect({
    indicatorType: "sellarCredit",
    overrideText: canAccessTab ? (
      invoiceId ? (
        <Link
          to={financeLink}
          className="group flex cursor-pointer items-center gap-2"
        >
          <span className="group-hover:underline">{message}</span>
          <Icon icon="CHEVRON_RIGHT" size={0.7} />
        </Link>
      ) : (
        <div className="flex items-center gap-2">{message}</div>
      )
    ) : (
      <span>{message}</span>
    ),
  });

  return (
    <div
      className="relative inline-flex flex-col items-center overflow-x-visible"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {!canAccessTab && userType === "supplier" && (
        <Transition show={showTooltip}>
          <div
            className="absolute -top-15 flex cursor-pointer items-center gap-1 rounded-lg border border-zinc-300 bg-zinc-50 px-4 py-3 text-xs font-semibold whitespace-nowrap shadow-lg"
            onClick={() => {
              window.open(
                "https://intercom.help/sellario/en/articles/10709865-supplier-guide-how-do-payouts-work-for-sellar-credit",
                "_blank ",
              );
            }}
          >
            <Icon
              icon="INFORMATION_OUTLINE"
              size={0.65}
              className="flex-none"
            />
            Learn more about Sellar Credit here
            <Icon icon="CHEVRON_RIGHT" size={1} className="flex-none" />
            <span className="absolute -bottom-[6.5px] ml-[calc(50%-20px)] block h-3 w-3 rotate-45 border-r border-b border-zinc-300 bg-zinc-50" />
          </div>
        </Transition>
      )}
      {indicator.full}
    </div>
  );
};
